var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"pa-0",attrs:{"fluid":""}},[_c('v-row',[_c('v-col',{staticClass:"pt-6",attrs:{"cols":"12","md":"6"}},[_c('About')],1),_c('v-col',{staticClass:"pt-6",attrs:{"cols":"12","md":"6"}},[_c('Base')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }